export default "__VITE_ASSET__4f265d4c__"